module.exports = __webpack_public_path__ + "img/loader.8820dcc7.gif";